import { toast } from 'react-toastify';

class ToastNotificationHelper {
    
    notifyInfo(message: string, secondsValid?: number): string | number {
		if (secondsValid == null) {
			secondsValid = 10;
		}

       var toastId = toast.info(message, {
            position: "bottom-right",
            autoClose: secondsValid * 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            pauseOnFocusLoss: false,
            draggable: true,
            progress: undefined
        });	

        return toastId;
	}

    notifyError(message: string, secondsValid?: number): string | number {
		if (secondsValid == null) {
			secondsValid = 10;
		}
				
        var toastId = toast.error(message, {
            position: "bottom-right",
            autoClose: secondsValid * 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            pauseOnFocusLoss: false,
            draggable: true,
            progress: undefined
        });
        
        return toastId;
	}

    dismiss(toastId: string | number): void {
        toast.dismiss(toastId);
    }
}

export default new ToastNotificationHelper();